/**
 * Normalizes v2 API auth responses to the frontend's internal shape.
 * This is a permanent adapter between the v2 API response shape and
 * the shape the rest of the app expects (e.g. UserInfo) — not a
 * migration shim.
 */

/**
 * Normalize v2 coach login/register/activation response.
 * V2 renames: customerAccessToken (v2) → customerToken (frontend)
 * V2 drops: hasCustomerAccount (derived from token presence)
 */
export const normalizeV2CoachAuthResponse = (data: any) => ({
  ...data,
  customerToken: data.customerAccessToken ?? null,
  hasCustomerAccount: !!data.customerAccessToken,
  hasCoachAccount: true,
});

/**
 * Normalize v2 customer login/verify response.
 * V2 semantics: accessToken = always coach, customerAccessToken = always customer.
 * Frontend semantics: accessToken = active token (whichever role logged in).
 */
export const normalizeV2CustomerAuthResponse = (data: any) => ({
  ...data,
  customer: {
    ...data.customer,
    emailAddress: data.customer?.email,
  },
  accessToken: data.customerAccessToken,
  coachToken: data.accessToken ?? null,
  hasCoachAccount: !!data.accessToken,
  hasCustomerAccount: true,
});
